"use strict";

exports.__esModule = true;
exports.TAG_DISPLAY_PARAMS = exports.TAG_LAYOUT_PARAMS = exports.TAG_DESIGN_PARAMS = exports.TAG_ORDERS = exports.TAG_ALIGNMENTS = exports.isTagLayoutButton = exports.DEFAULT_TAG_LAYOUT = exports.TAG_LAYOUTS = exports.TAG_LAYOUT_PATH = exports.TAG_LAYOUT = exports.IS_TAG_LABEL_ENABLED_PATH = exports.IS_TAG_LABEL_ENABLED = void 0;
var IS_TAG_LABEL_ENABLED = 'post-isTagLabelEnabled';
exports.IS_TAG_LABEL_ENABLED = IS_TAG_LABEL_ENABLED;
var IS_TAG_LABEL_ENABLED_PATH = "style.booleans." + IS_TAG_LABEL_ENABLED;
exports.IS_TAG_LABEL_ENABLED_PATH = IS_TAG_LABEL_ENABLED_PATH;
var TAG_LAYOUT = 'tagLayout';
exports.TAG_LAYOUT = TAG_LAYOUT;
var TAG_LAYOUT_PATH = "style.numbers." + TAG_LAYOUT;
exports.TAG_LAYOUT_PATH = TAG_LAYOUT_PATH;
var TAG_LAYOUTS = {
  button: 0,
  text: 1
};
exports.TAG_LAYOUTS = TAG_LAYOUTS;
var DEFAULT_TAG_LAYOUT = TAG_LAYOUTS.button;
exports.DEFAULT_TAG_LAYOUT = DEFAULT_TAG_LAYOUT;

var isTagLayoutButton = function isTagLayoutButton(tagLayout) {
  return tagLayout === TAG_LAYOUTS.button;
};

exports.isTagLayoutButton = isTagLayoutButton;
var TAG_ALIGNMENTS = {
  left: 0,
  center: 1,
  right: 2
};
exports.TAG_ALIGNMENTS = TAG_ALIGNMENTS;
var TAG_ORDERS = {
  mostUsed: 0,
  alphabetical: 1
};
exports.TAG_ORDERS = TAG_ORDERS;
var TAG_DESIGN_PARAMS = {
  textFont: {
    wixParam: 'tagTextFont',
    appSettingsPath: 'style.numbers.tagTextFont',
    defaultSize: 14,
    minSize: 10,
    maxSize: 24,
    defaultTheme: 'font_8'
  },
  textColor: {
    wixParam: 'tagTextColor',
    defaultColor: 'color-5'
  },
  textColorHover: {
    wixParam: 'tagTextColorHover',
    defaultColor: 'color-5'
  },
  backgroundColor: {
    wixParam: 'tagBackgroundColor',
    appSettingsPath: 'style.colors.tagBackgroundColor',
    defaultColor: 'color-1',
    defaultOpacity: 1
  },
  backgroundColorHover: {
    wixParam: 'tagBackgroundColorHover',
    appSettingsPath: 'style.colors.tagBackgroundColorHover',
    defaultColor: 'color-1',
    defaultOpacity: 1
  },
  borderColor: {
    wixParam: 'tagBorderColor',
    defaultColor: 'color-5',
    defaultOpacity: 0.2
  },
  borderColorHover: {
    wixParam: 'tagBorderColorHover',
    defaultColor: 'color-5',
    defaultOpacity: 0.6
  },
  borderWidth: {
    wixParam: 'tagBorderWidth',
    appSettingsPath: 'style.numbers.tagBorderWidth',
    defaultWidth: 1,
    minWidth: 0,
    maxWidth: 50
  },
  cornerRadius: {
    wixParam: 'tagCornerRadius',
    appSettingsPath: 'style.numbers.tagCornerRadius',
    defaultRadius: 0,
    minRadius: 0,
    maxRadius: 100
  }
};
exports.TAG_DESIGN_PARAMS = TAG_DESIGN_PARAMS;
var TAG_LAYOUT_PARAMS = {
  tagAlignment: {
    wixParam: 'tagTextAlignment',
    appSettingsPath: 'style.numbers.tagTextAlignment',
    defaultAlignment: TAG_ALIGNMENTS.left
  },
  verticalPadding: {
    wixParam: 'tagVerticalPadding',
    appSettingsPath: 'style.numbers.tagVerticalPadding',
    defaultPadding: 6,
    minPadding: 0,
    maxPadding: 100
  },
  horizontalPadding: {
    wixParam: 'tagHorizontalPadding',
    appSettingsPath: 'style.numbers.tagHorizontalPadding',
    defaultPadding: 12,
    minPadding: 0,
    maxPadding: 100
  },
  verticalSpacing: {
    wixParam: 'tagVerticalSpacing',
    appSettingsPath: 'style.numbers.tagVerticalSpacing',
    defaultSpacing: 8,
    minSpacing: 0,
    maxSpacing: 100
  },
  horizontalSpacing: {
    wixParam: 'tagHorizontalSpacing',
    appSettingsPath: 'style.numbers.tagHorizontalSpacing',
    defaultSpacing: 8,
    minSpacing: 0,
    maxSpacing: 100
  }
};
exports.TAG_LAYOUT_PARAMS = TAG_LAYOUT_PARAMS;
var TAG_DISPLAY_PARAMS = {
  showPostCount: {
    wixParam: 'tagShowPostCount',
    appSettingsPath: 'style.booleans.tagShowPostCount',
    defaultValue: true
  },
  orderTags: {
    wixParam: 'tagOrderTags',
    appSettingsPath: 'style.numbers.tagOrderTags',
    defaultValue: TAG_ORDERS.mostUsed
  },
  numberOfTags: {
    wixParam: 'tagNumberOfTags',
    appSettingsPath: 'style.numbers.tagNumberOfTags',
    defaultValue: 75,
    minValue: 1,
    maxValue: 100
  }
};
exports.TAG_DISPLAY_PARAMS = TAG_DISPLAY_PARAMS;